import { useEffect } from 'react';

import { logError } from 'services/logging/logging';
import { GenericError } from 'support/helpers/errors/errors';
import { OrderFormProductDTO } from 'support/types/dtos';

export const useProductPartsCount = (product: OrderFormProductDTO) => {
  useEffect(() => {
    if (product.parts && product.parts.length > 1) {
      logError(new GenericError('Order Forms: Product contains more than one part', product));
    }
  }, [product, product.parts]);

  if (!product.parts || product.parts.length > 1) {
    return null;
  }
  return product.parts?.[0]?.quantity_higher_packaging_unit ?? null;
};
